import { useState } from 'react';

function useModalToggle(initialState = false) {
  const [open, setOpen] = useState(initialState);

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  return {
    open,
    openModal,
    closeModal,
  };
}

export default useModalToggle;
